import SharePointUpload from '../components/psc/lib/SharePointUpload'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'
import useQualityContents from '../hooks/useQualityContents'

const QmsDocumentSharePointUpload = () => {
    useBrowserTabTitle('QMS Document SharePoint Upload')

    const {
        updateQmsDocument,
    } = useQualityContents()

    return (
        <SharePointUpload
            entityType="Document"
            apiPath="qms_documents"
            statusField="qms_document_status"
            successCallback={(obj) => updateQmsDocument(obj)}
        />
    )
}

export default QmsDocumentSharePointUpload
